import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSiteUrl } from '../../utils/seo';

const breadcrumbMap: Record<string, string> = {
  '/': 'ホーム',
  '/about': 'サロン紹介',
  '/information': 'お知らせ',
  '/recruit': '採用情報',
  '/style': 'スタイル紹介',
  '/contact': 'お問い合わせ',
};

export default function BreadcrumbSchema() {
  const location = useLocation();

  useEffect(() => {
    const siteUrl = getSiteUrl();
    const currentPath = location.pathname;

    if (currentPath === '/') return;

    const breadcrumbList = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'ホーム',
          item: siteUrl,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: breadcrumbMap[currentPath] || 'ページ',
          item: `${siteUrl}${currentPath}`,
        },
      ],
    };

    // Remove existing breadcrumb schema
    const existingBreadcrumb = document.querySelector('script[data-breadcrumb="true"]');
    if (existingBreadcrumb) {
      existingBreadcrumb.remove();
    }

    // Add new breadcrumb schema
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-breadcrumb', 'true');
    script.textContent = JSON.stringify(breadcrumbList);
    document.head.appendChild(script);

    return () => {
      const breadcrumbScript = document.querySelector('script[data-breadcrumb="true"]');
      if (breadcrumbScript) {
        breadcrumbScript.remove();
      }
    };
  }, [location]);

  return null;
}
